import React, { useState, useContext } from "react";
import { User, Phone, MapPin, Building, EyeClosed, Eye } from "lucide-react";

import styles from "./styles.module.css";

const PersonalCard = ({ name, plan, email, phone, cnpj, localization }) => {
    console.log("personalCard: ", name, plan, email, phone, cnpj, localization);
    const [isVisible, setIsVisible] = useState(false);
    /* == CARD DADOS PESSOAIS == */
    const getPlanInfo = (plan) => {
        console.log(plan)
        const plans = {
            free: { name: "Gratuito", limit: "1 nota por semana", color: styles.free },
            plus: { name: "Plus", limit: "5 notas por semana", color: styles.plus },
            premium: { name: "Premium", limit: "Ilimitado", color: styles.premium }
        };
        return plans[plan] || plans.free;        
    }
    //console.log('planInfo: ', user?.plan);
    const planInfo = getPlanInfo(plan);
    /* == CARD DADOS PESSOAIS == */

    return(
            <div className={styles.card}>
                <div className={styles.preVisibel}>
                    <div>
                        <h2 className={styles.title}>Bem-vindo(a), {name?.split(" ")[0]}! 👋</h2>
                        <p className={styles.subtitle}>
                            Seu plano atual: {" "}
                            <span className={`${styles.plan} ${planInfo.color}`}>
                                {planInfo.name}
                            </span>{" "}
                            - {planInfo.limit} 
                        </p>
                    </div>
                    <button className={styles.btn} onClick={() => setIsVisible(!isVisible)}>
                        {isVisible ? <Eye color="#4f46e5" /> : <EyeClosed color="#4f46e5" />}
                    </button>
                </div>

                {isVisible && (
                <div className={styles.grid}>
                    <div className={styles.infoItem}>
                        <User className={styles.icon} />
                        <span className={styles.text}>{email}</span>
                    </div>

                    {phone && (
                        <div className={styles.infoItem}>
                            <Phone className={styles.icon} />
                            <span className={styles.text}>{phone}</span>
                        </div>
                    )}

                    {cnpj && (
                        <div className={styles.infoItem}>
                            <Building className={styles.icon} />
                            <span className={styles.text}>{cnpj}</span>
                        </div>
                    )}

                    {localization.city && (
                        <div className={styles.infoItem}>
                            <MapPin className={styles.icon} />
                            <span className={styles.text}>
                                {localization?.address}, {localization?.city}, {localization?.state}
                            </span>
                        </div>
                    )}
                </div> )}
            </div>
    )
}

export default PersonalCard;